import {
  WppIconTableSort,
  WppIconTableSortAsc,
  WppIconTableSortDesc,
  WppSpinner,
  WppTypography,
  WppSkeleton,
} from '@wppopen/components-library-react'
import type { ColDef, Column } from 'ag-grid-community'

export function sortIcon(column: Column) {
  switch (true) {
    case column.isSortDescending():
      return <WppIconTableSortDesc />
    case column.isSortAscending():
      return <WppIconTableSortAsc />
    default:
      return <WppIconTableSort />
  }
}

export function NoDataOverlay() {
  return (
    <WppTypography tag="p" type="l-midi">
      Sorry, no data overlay
    </WppTypography>
  )
}

export function LoadingOverlay() {
  return <WppSpinner size="m" data-testid="loading-component" />
}

export const initialisationColDef = (columnData: ColDef<any>[]): ColDef<any>[] => {
  return columnData.map(column => {
    return {
      ...column,
      sortable: false,
      cellRenderer: () => <WppSkeleton variant="rectangle" height={22} data-testid="table-cell-skeleton" />,
    }
  })
}

export const initialisationRowData = (columnData: ColDef<any>[]): any[] => {
  const blankColDef = columnData.map(() => '')
  const rows = 25
  const rowData = []
  for (let i = 0; i < rows; i++) {
    rowData.push(blankColDef)
  }

  return rowData
}
